import * as React from "react";
import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { Spinner } from "../ui/spinner";

interface IProps {
  editing: boolean;
  saving: boolean;
  onCustomise(): void;
  onAutoLayout(): void;
  onReset(): void;
  onCancel(): void;
  onSave(): void;
}

const DashboardEditActions = ({ editing, saving, onCustomise, onAutoLayout, onReset, onCancel, onSave }: IProps) => {
  const { t } = useTranslation();

  if (!editing) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={(
              <Button
                type="button"
                variant="outline"
                size="icon"
                onClick={onCustomise}
                aria-label={t("Dashboard::Customise")}
              />
            )}
          >
            <Settings />
          </TooltipTrigger>
          <TooltipContent>{t("Dashboard::Customise")}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button type="button" variant="outline" onClick={onAutoLayout} disabled={saving}>
        {t("Dashboard::Auto layout")}
      </Button>
      <Button type="button" variant="outline" onClick={onReset} disabled={saving}>
        {t("Dashboard::Reset to default")}
      </Button>
      <Button type="button" variant="outline" onClick={onCancel} disabled={saving}>
        {t("Dashboard::Cancel")}
      </Button>
      <Button type="button" onClick={onSave} disabled={saving}>
        {saving && <Spinner data-icon="inline-start" />}
        {t("Dashboard::Save")}
      </Button>
    </div>
  );
};

export default DashboardEditActions;
